import { CompositionEditor } from '@/app/layout/CompositionEditor'
import { TopBar } from '@/app/layout/TopBar'
import { ToolPanel } from '@/app/layout/ToolPanel'

export function DesktopLayout({ onChooseImage }: { onChooseImage: () => void }) {
  return (
    <div className="flex h-dvh flex-col overflow-hidden">
      <TopBar mobile={false} onChooseImage={onChooseImage} />
      <main className="grid min-h-0 flex-1 grid-cols-[minmax(0,1fr)_360px]">
        <section className="min-h-0 overflow-hidden" aria-label="Composition workspace">
          <CompositionEditor />
        </section>
        <aside className="flex min-h-0 flex-col overflow-hidden border-l bg-background" aria-label="Editing tools">
          <div className="min-h-0 flex-1"><ToolPanel /></div>
        </aside>
      </main>
    </div>
  )
}
